import React, { ReactEventHandler } from 'react'

import { useFormatCurrency } from '@src/hooks/useFormatCurrency'
import { useMarketplace } from '@src/hooks/useMarketplace'

import {
  ButtonContainer,
  SpaceBetweenContent,
  StyledCheckoutButton,
} from './CheckoutButton.styles'

export const CheckoutButton: React.FC<{
  label: string
  onClick?: ReactEventHandler<HTMLButtonElement>
  loading?: boolean
  sumTotal?: number
  dataTestId?: string
}> = ({ label, sumTotal, onClick, loading = false, dataTestId }) => {
  const { featureOrdering } = useMarketplace()
  const formatCurrency = useFormatCurrency()

  const content =
    sumTotal === undefined ? (
      label
    ) : (
      <SpaceBetweenContent>
        <p>{label}</p>
        <p>{formatCurrency(sumTotal)}</p>
      </SpaceBetweenContent>
    )
  return (
    <ButtonContainer>
      <StyledCheckoutButton
        loading={loading}
        content={content}
        onClick={onClick}
        type={onClick ? 'button' : 'submit'}
        disabled={loading || !featureOrdering}
        dataTestId={dataTestId}
      />
    </ButtonContainer>
  )
}
